import React, { createContext, useState, useContext } from "react";

// Creating the Context
const FilterContext = createContext();

// Creating a custom hook to use the context
export const useFilter = () => {
  return useContext(FilterContext);
};

// Creating the Provider component
export const FilterProvider = ({ children }) => {
  const [selectedLocation, setSelectedLocation] = useState("");
  const [selectedRoom, setSelectedRoom] = useState("");
  const [selectedPrice, setSelectedPrice] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [isFilterApplied, setIsFilterApplied] = useState(false);

  return (
    <FilterContext.Provider
      value={{
        selectedLocation,
        selectedRoom,
        selectedPrice,
        filteredUsers,
        isFilterApplied,
        setSelectedLocation,
        setSelectedRoom,
        setSelectedPrice,
        setFilteredUsers,
        setIsFilterApplied
        // handleClearFilters,
        // handleSearch,
      }}
    >
      {children}
    </FilterContext.Provider>
  );
};